<template>
    <div class="myPage90 m_flex m_ais m_jcsb">
        <div class="rightBox">
            <!-- 列表样式 -->
            <div class="listStyleBox" v-if="pageType == 1">
                <!-- 表头 -->
                <div class="tableLine">
                    <el-row :gutter="20" class="tableLineBigBox" type="flex" align="middle">
                        <el-col :span="3"><div class="th">比较</div></el-col>
                        <el-col :span="3"><div class="th">货号</div></el-col>
                        <el-col :span="3"><div class="th">产品名称</div></el-col>
                        <el-col :span="4"><div class="th">产品描述</div></el-col>
                        <el-col :span="3"><div class="th">产品属性</div></el-col>
                        <el-col :span="4"><div class="th m_jcc">价格</div></el-col>
                    </el-row>
                </div>
                <!-- v-for循环tableLine -->
                <div class="tableLine" v-for="(item, index) in lists" :key="index">
                    <el-row :gutter="20" class="tableLineBigBox" type="flex" align="middle">
                        <el-col :span="3">
                            <div
                                class="m_checkBox"
                                :class="{ disabled: vuex_compare_popup_list.length == 4 && !isSelect(item), active: isSelect(item) }"
                                @click="compareSelectFun(item)"
                            >
                                <i class="el-icon-check m_checkIcon"></i>
                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div class="idCode">{{ item.zSn ? item.zSn : '‎' }}</div>
                        </el-col>
                        <el-col :span="3">
                            <div class="redTitle" @click="goProductDetail(item)">{{ item.title ? item.title : '‎' }}</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="intro">{{ item.jianjie || item.core_parameters || item.description || '‎' }}</div>
                        </el-col>
                        <el-col :span="3">
                            <div class="intro">{{ item.product_grade ? item.product_grade : '‎' }}</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="queryBox m_flex m_aic m_jce" @click="showDetail(item, index)" v-show="!item.show">
                                <div class="text">查看定价</div>
                                <img src="@/assets/images/productList/selectIcon.png" class="selectIcon3" alt="" />
                            </div>
                            <div class="queryBox m_flex m_aic m_jce" @click="showDetail(item, index)" v-show="item.show">
                                <div class="text">隐藏</div>
                            </div>
                        </el-col>
                    </el-row>
                    <!-- <div class="tableLineBox">
                            <div class="tableLineBox m_flex m_aic m_jcsb">
                                <div class="tableItem">
                                    <div
                                        class="m_checkBox"
                                        :class="{ disabled: vuex_compare_popup_list.length == 4 && !isSelect(item), active: isSelect(item) }"
                                        @click="compareSelectFun(item)"
                                    >
                                        <i class="el-icon-check m_checkIcon"></i>
                                    </div>
                                </div>
                                <div class="tableItem3">
                                    <div class="idCode">{{ item.zSn }}</div>
                                </div>
                                <div class="tableItem4">
                                    <div class="redTitle" @click="goProductDetail(item)">{{ item.title }}</div>
                                </div>
                                <div class="tableItem2">
                                    <div class="intro">{{ item.jianjie }}</div>
                                </div>
                                <div class="tableItem nopadd">
                                    <div class="queryBox m_flex m_aic m_jce" @click="showDetail(item, index)" v-show="!item.show">
                                        <div class="text">查看定价</div>
                                        <img src="@/assets/images/productList/selectIcon.png" class="selectIcon3" alt="" />
                                    </div>
                                    <div class="queryBox m_flex m_aic m_jce" @click="showDetail(item, index)" v-show="item.show">
                                        <div class="text">隐藏</div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                    <!-- 不展开就把这里隐藏 -->
                    <div class="loginRedBox m_flex m_aic m_jcc" v-if="false">
                        <div class="redLoginText">登录</div>
                        <div class="blackLoginText">查看公司和协议定价</div>
                    </div>
                    <!-- 不展开就把这里隐藏 -->
                    <div class="priceBigBox" v-show="item.show">
                        <div class="itemLineBox">
                            <el-row :gutter="20" type="flex" align="middle">
                                <el-col :span="3"><div class="priceTitleText">货号</div></el-col>
                                <el-col :span="3"><div class="priceTitleText">包装规格</div></el-col>
                                <el-col :span="3"><div class="priceTitleText">是否有货</div></el-col>
                                <el-col :span="3"><div class="priceTitleText">产品属性</div></el-col>
                                <el-col :span="3"><div class="priceTitleText">价格</div></el-col>
                                <el-col :span="4"><div class="priceTitleText">数量</div></el-col>
                                <el-col :span="2"><div class="priceTitleText">‎</div></el-col>
                            </el-row>
                        </div>

                        <div class="itemLineBox" v-for="(item2, index2) in item.skus" :key="index2">
                            <el-row :gutter="20" type="flex" align="middle">
                                <el-col :span="3">
                                    <div class="priceText">{{ item2.sn ? item2.sn : '‎' }}</div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="priceText">{{ item2.keyVals || item2.spec || item2.title || '‎' }}</div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="priceText">
                                        <div class="priceText2" v-if="item2.kucun > 0">
                                            <i class="el-icon-circle-check yesIcon"></i>有货<span class="detailText" v-if="false">详情</span>
                                        </div>
                                        <div class="priceText2" v-else>无货<span class="detailText" v-if="false">详情</span></div>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="priceText">{{ item.product_grade ? item.product_grade : '‎' }}</div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="priceText">¥{{ item2.priceSale ? item2.priceSale : '‎' }}</div>
                                </el-col>
                                <el-col :span="4">
                                    <el-input-number v-model="item2.num" size="mini" :min="0" :max="item2.kucun" label=""></el-input-number>
                                </el-col>
                                <el-col :span="2">
                                    <i class="el-icon-warning warningIcon" @click="productDetailWinSwitch('打开', item2, item)"></i>
                                </el-col>
                            </el-row>
                        </div>

                        <!-- <div class="itemLineBox m_flex m_aic m_jcsb">
                            <div class="priceItem">
                                <div class="priceText">{{ item2.sn }}</div>
                            </div>
                            <div class="priceItem">
                                <div class="priceText">{{ item.spec }}</div>
                            </div>
                            <div class="priceItem">
                                <div class="priceText2">
                                    <i class="el-icon-circle-check yesIcon"></i>预计发货时间 2025年7月16日 <span class="detailText">详情</span>
                                </div>
                                <div class="priceText2" v-if="item2.kucun > 0">
                                    <i class="el-icon-circle-check yesIcon"></i>有货<span class="detailText" v-if="false">详情</span>
                                </div>
                                <div class="priceText2" v-else>无货<span class="detailText" v-if="false">详情</span></div>
                            </div>
                            <div class="priceItem">
                                <div class="priceText">¥{{ item2.priceSale }}</div>
                            </div>
                            <div class="priceItem m_flex m_aic m_jcsb">
                                <el-input-number v-model="item2.num" size="mini" :min="0" :max="item2.kucun" label=""></el-input-number>
                                <i class="el-icon-warning warningIcon" @click="productDetailWinSwitch('打开', item2)"></i>
                            </div>
                        </div> -->
                        <div class="btnFlexBox m_flex m_aic m_jce">
                            <div class="addCar m_flex m_aic m_jcc active" @click="addCar(item)">加入购物车</div>
                        </div>
                    </div>
                </div>
                <div class="m_fcc" style="width: 100%">
                    <el-empty v-if="lists.length == 0" description="暂无内容"> </el-empty>
                </div>
            </div>

            <!-- 卡片样式 -->
            <div class="cardListBox m_flex m_ais m_jcs m_wrap" v-if="pageType == 2">
                <div class="itemBox" v-for="(item, index) in lists" :key="index">
                    <div class="compareBox m_flex m_aic m_jcs">
                        <div class="m_checkBox" :class="{ active: isSelect(item) }" @click="compareSelectFun(item)">
                            <i class="el-icon-check m_checkIcon"></i>
                        </div>
                        <div class="text">比较</div>
                    </div>
                    <div class="imgBox m_flex m_aic m_jcc">
                        <img :src="item.thumb ? item.thumb : vuex_default_img" class="img" alt="" />
                    </div>
                    <div class="redId" @click="goProductDetail(item)">{{ item.zSn }}</div>
                    <div class="name m_line_3">{{ item.title }}</div>
                    <div class="introText m_line_3">{{ item.jianjie }}</div>
                    <div class="btn m_flex m_aic m_jcc btn-ripple" @click="queryDetialWinSwitch('打开', item)">快速浏览</div>
                </div>

                <div class="m_fcc" style="width: 100%">
                    <el-empty v-if="lists.length == 0" description="暂无内容"> </el-empty>
                </div>
            </div>
        </div>

        <!-- 快速浏览弹窗 -->
        <div class="queryDetailWin m_flex m_aic m_jcc" v-if="queryDetailWin">
            <div class="winBox m_flex m_aic m_jcsb">
                <div class="lBox m_flex m_ais m_jcsb">
                    <div class="iconBox">
                        <img src="@/assets/images/index/demoImg.png" class="icon" alt="" />
                    </div>
                    <div class="rContentBox">
                        <div class="redText m_line_1" @click="goDetailPage">{{ productDetailWinObj2.zSn }}</div>
                        <div class="blackText m_line_1">{{ productDetailWinObj2.title }}</div>
                        <div class="skuText m_line_1" v-if="false">yellow，WXL3/4 in</div>
                        <div class="loginRedBox m_flex m_aic m_jcc" v-if="false">
                            <div class="redLoginText">登录</div>
                            <div class="blackLoginText">查看公司和协议定价</div>
                        </div>

                        <div class="skuScrollYBox">
                            <div class="skuBigBox" v-for="(item, index) in 1" :key="index">
                                <div class="skuTopTitle">规格</div>
                                <div class="skuFlexBox m_flex m_ais m_jcs m_wrap">
                                    <div
                                        class="skuItem m_flex m_fdc m_aic m_jcc active"
                                        v-for="(item2, index2) in productDetailWinObj2.skus"
                                        :key="index2"
                                    >
                                        <div class="text">{{ productDetailWinObj2.spec }}</div>
                                        <div class="text2">¥{{ item2.priceSale }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rBox">
                    <div class="closeBtn m_flex m_aic m_jcc" @click="queryDetialWinSwitch('关闭')">
                        <img src="@/assets/images/del.png" class="delBtn" alt="" />
                    </div>
                    <div class="topTitle m_line_1">{{ productDetailWinObj2.title }}</div>
                    <div class="redMoneyText">¥{{ productDetailWinObj2.priceSale }}</div>
                    <div class="rGreyLine"></div>
                    <!-- <div class="hintTextBox">
                        <i class="el-icon-circle-check yesIcon"></i><span class="priceText2">预计发货时间 2025年7月16日</span
                        ><span class="detailText">详情</span>
                    </div> -->
                    <div class="hintTextBox" v-if="productDetailWinObj2.kucun > 0">
                        <i class="el-icon-circle-check yesIcon"></i><span class="priceText2">有货</span>
                    </div>
                    <div class="hintTextBox" v-else><span class="priceText2">无货</span></div>
                    <div class="rGreyLine"></div>
                    <div class="myInputNumber">
                        <el-input-number v-model="num" :min="1" :max="productDetailWinObj2.kucun" size="small"></el-input-number>
                    </div>
                    <div class="addCarRedBtn m_flex m_aic m_jcc btn-ripple" @click="addCart">加入购物车</div>
                </div>
            </div>
        </div>

        <!-- 产品信息弹窗 -->
        <div class="productDetailWin m_flex m_aic m_jcc" v-if="productDetailWin">
            <div class="winBox">
                <div class="titleFlexBox m_flex m_aic m_jcsb">
                    <div class="title">产品信息</div>
                    <div class="closeBtn m_flex m_aic m_jcc" @click="productDetailWinSwitch('关闭')">
                        <img src="@/assets/images/del.png" class="delBtn" alt="" />
                    </div>
                </div>

                <div class="contextLineBox m_flex m_ais m_jcs">
                    <div class="titleBox">材料编号 / SKU：</div>
                    <div class="textBox">
                        {{ productDetailWinObj.sn }}
                    </div>
                </div>
                <div class="contextLineBox m_flex m_ais m_jcs">
                    <div class="titleBox">描述：</div>
                    <div class="textBox">
                        {{ productDetailWinDescription }}
                    </div>
                </div>
                <!-- <div class="greyLineBox"></div>
                <div class="contextLineBox m_flex m_ais m_jcs noMb">
                    <div class="titleBox">外贸商品法案：</div>
                    <div class="textBox">
                        文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // 1.列表样式，2.卡片样式
        pageType: {
            required: false,
            default: 1,
        },
        list: {
            required: false,
            default: [],
        },
    },
    computed: {
        isSelect() {
            return (val) => {
                for (let index = 0; index < this.vuex_compare_popup_list.length; index++) {
                    let item = this.vuex_compare_popup_list[index]
                    if (val.inventoryId == item.inventoryId) {
                        return true
                    }
                }

                return false
            }
        },
        // 产品信息弹窗「描述」：与列表「产品描述」一致，优先 jianjie 再 core_parameters 再 description
        productDetailWinDescription() {
            const p = this.productDetailWinProduct
            if (!p) return ''
            const s = (p.jianjie && String(p.jianjie).trim()) || (p.core_parameters && String(p.core_parameters).trim()) || (p.description && String(p.description).trim())
            return s || ''
        },
    },
    watch: {
        list: {
            immediate: true,
            deep: true,
            handler(newV) {
                this.lists = newV
            },
        },
    },
    data() {
        return {
            num: 1,
            queryDetailWin: false, // 快速浏览
            productDetailWin: false, // 产品信息弹窗
            lists: [],

            productDetailWinObj: {}, // 当前弹窗的 SKU（材料编号等）
            productDetailWinProduct: null, // 当前弹窗所属的产品（用于描述，与列表「产品描述」一致）

            productDetailWinObj2: {},
        }
    },
    created() {},
    mounted() {},
    methods: {
        compareSelectFun(item2) {
            let delIndex = -1
            for (let index = 0; index < this.vuex_compare_popup_list.length; index++) {
                let item = this.vuex_compare_popup_list[index]
                if (item.id == item2.id) {
                    delIndex = index
                    break
                }
            }
            let vuex_compare_popup_list = this.$cloneDeep(this.vuex_compare_popup_list)
            if (delIndex == -1) {
                // 添加
                if (vuex_compare_popup_list.length == 4) {
                    return
                }
                vuex_compare_popup_list.push(item2)
            } else {
                // 删除
                vuex_compare_popup_list.splice(delIndex, 1)
            }
            this.mix_setVuex('vuex_compare_popup_list', vuex_compare_popup_list)
        },
        goDetailPage() {
            this.$router.push({
                path: '/product-detail',
                query: { id: this.productDetailWinObj2.inventoryId },
            })
        },
        // 加入购物车
        async addCar(item) {
            if (!this.vuex_isLogin) {
                alertErr('请先登录')
                return
            }

            // 如果数量都选择的是0，则不继续
            let num2 = 0
            item['skus'].forEach((item2, index2) => {
                if (item2.num > 0) {
                    num2 = item2.num
                }
            })
            if (num2 == 0) {
                return
            }

            this.$load.open()
            for (let i = 0; i < item.skus.length; i++) {
                let item2 = item.skus[i]

                // 只将num大于0的商品加入购物车
                if (item2.num > 0) {
                    await this.mix_addCar(item2.id, item2.num)
                }
            }
            this.$load.close(300)
            alertSucc('添加成功')
        },
        showDetail(item, index) {
            if (item.show) {
                this.lists[index]['show'] = false
            } else {
                this.lists[index]['show'] = true
            }
        },
        handleCurrentChange(index) {},
        selectPageType(type) {
            this.pageType = type
        },
        productDetailWinSwitch(text, skuItem, productItem) {
            if (text == '打开') {
                this.productDetailWin = true
                this.productDetailWinObj = skuItem
                this.productDetailWinProduct = productItem || null
                return
            }

            if (text == '关闭') {
                this.productDetailWin = false
                this.productDetailWinProduct = null
                return
            }
        },
        queryDetialWinSwitch(text, item) {
            if (text == '打开') {
                this.queryDetailWin = true
                this.productDetailWinObj2 = item
                this.num = 1
                console.log(this.$cloneDeep(item))
                return
            }

            if (text == '关闭') {
                this.queryDetailWin = false
                return
            }
        },
        goProductDetail(item) {
            this.$router.push({
                path: '/product-detail',
                query: { id: item.skus[0]['id'] },
            })
        },

        async addCart() {
            if (!this.vuex_isLogin) {
                alertErr('请先登录')
                return
            }
            if (this.productDetailWinObj2.kucun == 0) {
                alertErr('库存不足')
                return
            }
            this.$load.open()
            await this.mix_addCar(this.productDetailWinObj2.inventoryId, this.num)
            this.$load.close(300)
            alertSucc('添加成功')
        },
    },
}
</script>

<style lang="less" scoped>
.productDetailWin {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.5);

    .winBox {
        width: 620px;
        background: #ffffff;
        border-radius: 5px 5px 5px 5px;
        position: relative;
        padding: 30px;

        .titleFlexBox {
            width: 100%;
            margin-bottom: 30px;

            .title {
                font-size: 20px;
                line-height: 26px;
                color: #000000;
                font-weight: 900;
            }

            .closeBtn {
                width: 30px;
                height: 30px;
                cursor: pointer;

                .delBtn {
                    width: 14px;
                    height: 14px;
                }
            }
        }

        .greyLineBox {
            width: 100%;
            height: 1px;
            background: lightgray;
            margin: 9px 0 15px 0;
        }

        .contextLineBox {
            width: 100%;
            margin-bottom: 6px;

            &.noMb {
                margin-bottom: 0;
            }

            .titleBox {
                font-size: 14px;
                line-height: 24px;
                color: #000000;
                font-weight: bold;
                width: 236px;
            }

            .textBox {
                font-size: 14px;
                line-height: 24px;
                color: #000000;
                font-weight: normal;
                width: calc(100% - 236px);
            }
        }
    }
}

.queryDetailWin {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.5);

    .winBox {
        width: 918px;
        height: 447px;
        background: #ffffff;
        border-radius: 5px 5px 5px 5px;
        position: relative;

        .lBox {
            padding: 26px 30px;
            width: 611px;
            height: 100%;
            position: relative;

            .iconBox {
                width: 88px;
                height: 85px;
                background: #ffffff;
                border-radius: 3px 3px 3px 3px;
                border: 1px solid #c9c9c9;
                margin-right: 25px;

                .icon {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }

            .rContentBox {
                width: calc(100% - 88px - 25px);
                height: 100%;

                .skuScrollYBox {
                    width: 100%;
                    height: calc(100% - 170px);
                    overflow-y: auto;
                    margin-top: 50px;

                    .skuBigBox {
                        width: 100%;
                        margin-top: 20px;

                        &:first-child {
                            margin-top: 0;
                        }

                        .skuTopTitle {
                            width: 100%;
                            font-weight: 900;
                            font-size: 18px;
                            color: #000000;
                            line-height: 25px;
                            text-align: left;
                            margin-bottom: 10px;
                        }

                        .skuFlexBox {
                            width: 100%;

                            .skuItem {
                                width: calc((100% - 20px * 3) / 4);
                                margin-right: 20px;
                                margin-top: 20px;
                                min-height: 62px;
                                background: #ffffff;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid gray;
                                cursor: pointer;

                                &:nth-child(4n) {
                                    margin-right: 0;
                                }

                                &:nth-child(-n + 4) {
                                    margin-top: 0;
                                }

                                &.active {
                                    background: #ffdbdb;
                                    border: 1px solid #d61818;
                                }

                                .text {
                                    font-weight: 900;
                                    font-size: 18px;
                                    color: #000000;
                                    line-height: 25px;
                                    text-align: center;
                                }

                                .text2 {
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #000000;
                                    line-height: 20px;
                                    text-align: center;
                                }
                            }
                        }
                    }
                }

                .redText {
                    width: 100%;
                    font-weight: bold;
                    font-size: 16px;
                    color: #d61818;
                    line-height: 24px;
                    text-align: left;
                    cursor: pointer;
                }

                .blackText {
                    width: 100%;
                    font-weight: 900;
                    font-size: 20px;
                    color: #000000;
                    line-height: 29px;
                    text-align: left;
                }

                .skuText {
                    width: 100%;
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                    line-height: 20px;
                    text-align: left;
                    margin-bottom: 34px;
                }

                .loginRedBox {
                    width: 100%;
                    height: 37px;
                    background: #ffdbdb;
                    border-radius: 3px 3px 3px 3px;
                    margin-bottom: 26px;

                    .redLoginText {
                        font-weight: 900;
                        font-size: 14px;
                        color: #d61818;
                        line-height: 20px;
                        text-align: left;
                        margin-right: 6px;
                        cursor: pointer;
                    }

                    .blackLoginText {
                        font-weight: 900;
                        font-size: 14px;
                        color: #000000;
                        line-height: 20px;
                        text-align: left;
                    }
                }
            }
        }

        .rBox {
            width: calc(100% - 611px);
            height: 100%;
            background: #f7f7fc;
            position: relative;
            padding: 26px 30px;

            .topTitle {
                width: calc(100% - 40px);
                font-weight: 900;
                font-size: 20px;
                color: #000000;
                line-height: 29px;
                text-align: left;
                margin-bottom: 12px;
            }

            .redMoneyText {
                width: 100%;
                font-weight: 900;
                font-size: 18px;
                color: #d61818;
                line-height: 25px;
                text-align: left;
            }

            .rGreyLine {
                width: 100%;
                height: 1px;
                background: lightgray;
                margin: 15px 0;
            }

            .closeBtn {
                width: 30px;
                height: 30px;
                cursor: pointer;
                position: absolute;
                top: 26px;
                right: 26px;

                .delBtn {
                    width: 14px;
                    height: 14px;
                }
            }

            .myInputNumber {
                margin-bottom: 20px;

                :deep .el-input-number {
                    width: 100%;
                }
            }

            .hintTextBox {
                width: 100%;

                .yesIcon {
                    font-size: 16px;
                    line-height: 20px;
                    color: #2b9f5f;
                    margin-right: 6px;
                }

                .priceText2 {
                    font-weight: normal;
                    font-size: 14px;
                    color: #000000;
                    line-height: 20px;
                    text-align: left;
                }

                .detailText {
                    font-weight: bold;
                    font-size: 14px;
                    color: #d61818;
                    line-height: 20px;
                    text-align: left;
                    margin-left: 6px;
                    cursor: pointer;
                }
            }

            .addCarRedBtn {
                width: 100%;
                height: 40px;
                background: #d61818;
                border-radius: 5px 5px 5px 5px;
                font-weight: bold;
                font-size: 16px;
                color: #ffffff;
                line-height: 24px;
                text-align: left;
                cursor: pointer;
            }
        }
    }
}

.myPage90 {
    height: fit-content;

    .rightBox {
        width: calc(100%);

        .topToolLineBox {
            width: 100%;
            margin-bottom: 30px;

            .m_inputBox {
                margin-right: 16px;
            }

            .toolLeftBox {
                .m_selectBox {
                    width: 240px;
                    margin-right: 16px;
                }

                .numBox {
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                    line-height: 20px;
                    text-align: left;
                }
            }

            .toolRightBox {
                .text {
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                    line-height: 20px;
                    text-align: left;
                    margin-right: 8px;
                }

                .viewSelectBox {
                    .viewBox {
                        cursor: pointer;
                        width: 30px;
                        height: 30px;
                        background: #ffffff;
                        border-radius: 0px 0px 0px 0px;
                        border: 1px solid #c9c9c9;

                        .listIcon {
                            display: none;
                            width: 16px;
                        }

                        .cellIcon {
                            display: none;
                            width: 14px;
                        }

                        .listIcon2 {
                            width: 16px;
                        }

                        .cellIcon2 {
                            width: 14px;
                        }

                        &.active {
                            background: #d61818;

                            .listIcon {
                                display: block;
                                width: 16px;
                            }

                            .listIcon2 {
                                width: 16px;
                                display: none;
                            }

                            .cellIcon {
                                display: block;
                                width: 14px;
                            }

                            .cellIcon2 {
                                width: 14px;
                                display: none;
                            }
                        }
                    }
                }
            }
        }

        .cardListBox {
            width: 100%;
            margin-bottom: 30px;

            .itemBox {
                width: calc((100% - 40px * 2) / 3);
                margin-right: 40px;
                margin-top: 30px;
                height: 380px;
                padding: 28px 16px;
                border-radius: 5px 5px 5px 5px;
                border: 1px solid #c9c9c9;
                position: relative;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                &:nth-child(-n + 3) {
                    margin-top: 0;
                }

                .compareBox {
                    margin-bottom: 8px;

                    .text {
                        margin-left: 5px;
                        font-weight: 400;
                        font-size: 16px;
                        color: #000000;
                        line-height: 24px;
                        text-align: left;
                    }
                }

                .imgBox {
                    width: 100%;
                    height: 100px;
                    margin-bottom: 6px;

                    .img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .redId {
                    width: fit-content;
                    cursor: pointer;
                    font-weight: 900;
                    font-size: 12px;
                    color: #d61818;
                    line-height: 24px;
                    text-align: left;
                }

                .name {
                    width: 100%;
                    font-weight: 900;
                    font-size: 16px;
                    color: #000000;
                    line-height: 22px;
                    max-height: 66px;
                    text-align: left;
                    margin-bottom: 6px;
                }

                .introText {
                    width: 100%;
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                    line-height: 20px;
                    text-align: left;
                    max-height: 60px;
                    margin-bottom: 20px;
                }

                .btn {
                    position: absolute;
                    bottom: 28px;
                    left: 16px;
                    width: calc(100% - 16px - 16px);
                    height: 36px;
                    border-radius: 5px 5px 5px 5px;
                    border: 1px solid #d61818;
                    font-weight: bold;
                    font-size: 14px;
                    color: #d61818;
                    line-height: 24px;
                    text-align: left;
                }
            }
        }

        .pageBigBox {
            width: 100%;

            .text {
                font-weight: 400;
                font-size: 14px;
                color: #000000;
                line-height: 24px;
                text-align: left;
            }

            .pageBox {
                :deep .el-pagination.is-background .el-pager li:not(.disabled).active {
                    background-color: #d61818;
                }
            }
        }

        .listStyleBox {
            width: 100%;
            margin-bottom: 30px;

            .tableLine {
                width: 100%;
                border-bottom: 1px solid lightgray;

                .loginRedBox {
                    width: 100%;
                    height: 37px;
                    background: #ffdbdb;
                    border-radius: 3px 3px 3px 3px;

                    .redLoginText {
                        font-weight: 900;
                        font-size: 14px;
                        color: #d61818;
                        line-height: 20px;
                        text-align: left;
                        margin-right: 6px;
                        cursor: pointer;
                    }

                    .blackLoginText {
                        font-weight: 900;
                        font-size: 14px;
                        color: #000000;
                        line-height: 20px;
                        text-align: left;
                    }
                }

                .priceBigBox {
                    width: 100%;
                    background: #f8f8fc;

                    .itemLineBox {
                        width: 100%;
                        box-sizing: border-box;
                        padding: 10px 18px;
                        border-bottom: 1px solid lightgray;

                        .priceTitleText {
                            font-weight: 900;
                            font-size: 14px;
                            color: #000000;
                            line-height: 18px;
                            text-align: left;
                        }

                        .priceText {
                            font-weight: normal;
                            font-size: 14px;
                            color: #000000;
                            line-height: 18px;
                            text-align: left;
                        }

                        .yesIcon {
                            font-size: 16px;
                            line-height: 20px;
                            color: #2b9f5f;
                            margin-right: 6px;
                        }

                        .priceText2 {
                            font-weight: normal;
                            font-size: 14px;
                            color: #000000;
                            line-height: 20px;
                            text-align: left;
                        }

                        .detailText {
                            font-weight: bold;
                            font-size: 14px;
                            color: #d61818;
                            line-height: 20px;
                            text-align: left;
                            margin-left: 6px;
                            cursor: pointer;
                        }

                        :deep .el-input-number__decrease:hover {
                            color: #d61818;
                        }

                        :deep .el-input-number__increase:hover {
                            color: #d61818;
                        }

                        :deep .el-input-number__decrease:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled),
                        :deep .el-input-number__increase:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled) {
                            border-color: #d61818;
                        }

                        :deep .el-input.is-active .el-input__inner,
                        :deep .el-input__inner:focus {
                            border-color: #d61818;
                        }

                        .warningIcon {
                            cursor: pointer;
                            font-size: 22px;
                            color: #d61818;
                        }

                        .priceItem {
                            width: calc(20% - 10px);
                        }

                        &:last-child {
                            border-bottom: 0;
                        }
                    }

                    .btnFlexBox {
                        width: 100%;
                        padding: 18px 18px;

                        .addCar {
                            cursor: pointer;
                            width: 133px;
                            height: 49px;
                            background: #898989;
                            border-radius: 5px 5px 5px 5px;
                            font-weight: bold;
                            font-size: 16px;
                            color: #ffffff;
                            line-height: 22px;
                            text-align: left;

                            &.active {
                                background: #d61818;
                            }
                        }
                    }
                }

                .tableLineBigBox {
                    width: 100%;
                    min-height: 56px;

                    .tableLineBox {
                        width: 100%;

                        .tableItem {
                            width: 10%;
                            padding-right: 10px;

                            &.nopadd {
                                padding: 0;
                            }
                        }

                        .tableItem3 {
                            width: 15%;
                            padding-right: 10px;

                            &.nopadd {
                                padding: 0;
                            }
                        }

                        .tableItem2 {
                            width: 35%;
                            padding-right: 10px;

                            &.nopadd {
                                padding: 0;
                            }
                        }

                        .tableItem4 {
                            width: 30%;
                            padding-right: 10px;

                            &.nopadd {
                                padding: 0;
                            }
                        }
                    }
                }

                .th {
                    font-weight: 900;
                    font-size: 14px;
                    color: #000000;
                    line-height: 56px;
                    text-align: left;

                    &.tar {
                        text-align: right;
                    }
                }

                .idCode {
                    width: fit-content;
                    cursor: pointer;
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                    line-height: 20px;
                    text-align: left;
                }

                .redTitle {
                    width: fit-content;
                    cursor: pointer;
                    font-weight: bold;
                    font-size: 14px;
                    color: #d61818;
                    line-height: 20px;
                    text-align: left;
                }

                .intro {
                    width: fit-content;
                    cursor: pointer;
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                    line-height: 20px;
                    text-align: left;
                }

                .queryBox {
                    width: 100%;
                    cursor: pointer;

                    .text {
                        font-weight: 900;
                        font-size: 14px;
                        color: #d61818;
                        line-height: 20px;
                        text-align: left;
                    }

                    .selectIcon3 {
                        width: 16px;
                    }
                }
            }
        }
    }
}

// select框的样式
:deep .el-input .el-input__inner {
    font-size: 16px;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #949494;
    color: #000000;
}

// select下拉的样式
.el-select-dropdown__item.selected {
    color: #000000 !important;
}
</style>
<style lang="less" scoped src="./style/h5-product-list.less"></style>
